import script from "./HeaderMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderMenu.vue?vue&type=script&setup=true&lang=js"

import "./HeaderMenu.vue?vue&type=style&index=0&id=1ccac381&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ccac381"]])

export default __exports__